var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFilter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.6654 2H3.33203C2.38922 2 1.91782 2 1.62492 2.2748C1.33203 2.5496 1.33203 2.99188 1.33203 3.87644V4.33632C1.33203 5.02821 1.33203 5.37416 1.5051 5.66095C1.67816 5.94773 1.99435 6.12572 2.62671 6.4817L4.56873 7.57492C4.99301 7.81376 5.20514 7.93318 5.35704 8.06505C5.67336 8.33966 5.86808 8.66234 5.95632 9.05811C5.9987 9.24816 5.9987 9.47054 5.9987 9.91529L5.9987 11.6949C5.9987 12.3013 5.9987 12.6045 6.16665 12.8409C6.3346 13.0772 6.63289 13.1938 7.22947 13.427C8.48189 13.9166 9.1081 14.1614 9.5534 13.8829C9.9987 13.6044 9.9987 12.9679 9.9987 11.6949V9.91529C9.9987 9.47054 9.9987 9.24816 10.0411 9.05811C10.1293 8.66234 10.324 8.33966 10.6404 8.06505C10.7923 7.93318 11.0044 7.81376 11.4287 7.57492L13.3707 6.4817C14.003 6.12572 14.3192 5.94773 14.4923 5.66095C14.6654 5.37416 14.6654 5.02821 14.6654 4.33632V3.87644C14.6654 2.99188 14.6654 2.5496 14.3725 2.2748C14.0796 2 13.6082 2 12.6654 2Z",
    fill: "#181D27"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilter);
export default __webpack_public_path__ + "static/media/filter.6a3a203339e847ac221bbd7e54ae59ff.svg";
export { ForwardRef as ReactComponent };